/**
 * Controls whether the color scheme manager should persist theme to localStorage.
 *
 * When a menu page sets the restaurant's color scheme (e.g. dark), we set this to true
 * so the manager does NOT write to localStorage. That prevents:
 * 1. Cross-tab flicker: other tabs (e.g. splash) won't receive a storage event and switch to dark
 * 2. Wrong initial theme on next load: new tabs won't read "dark" and show the wrong theme on non-menu routes
 *
 * Only the app shell (non-menu routes) should persist "light" to localStorage.
 */

let skipThemePersist = false;

export function getSkipThemePersist(): boolean {
  return skipThemePersist;
}

export function setSkipThemePersist(value: boolean): void {
  skipThemePersist = value;
}
